var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgIntercom = function SvgIntercom(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#intercom_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1E89E6",
    d: "M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-3.867 2.933c0-.292.24-.534.534-.534.294 0 .534.241.534.534v7.124a.535.535 0 0 1-1.068 0V2.932Zm-2.667-.271a.534.534 0 0 1 1.068 0v7.737a.534.534 0 0 1-1.068 0V2.662Zm-2.667.27c0-.291.24-.534.534-.534.295 0 .534.242.534.534v7.125a.535.535 0 0 1-1.067 0V2.932ZM2.134 4a.535.535 0 0 1 1.068 0v4.797a.535.535 0 0 1-1.068 0V4Zm11.547 8.136c-.081.07-2.058 1.729-5.68 1.729s-5.599-1.66-5.68-1.73a.533.533 0 0 1 .693-.812c.032.026 1.795 1.474 4.987 1.474 3.232 0 4.969-1.459 4.985-1.472a.533.533 0 1 1 .695.81Zm.187-3.339a.535.535 0 0 1-1.068 0V4a.535.535 0 0 1 1.068 0v4.797Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "intercom_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIntercom);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;